import FeatureGates from '@atlaskit/feature-gate-js-client';
import { UNSAFE_initIfNeeded } from '@atlassian/jira-feature-gates-unsafe-init';
import { addFeatureFlagAccessed } from '@atlassian/ufo-feature-flags-accessed';

export const fg: typeof FeatureGates.checkGate = (gateName) => {
	// Handle vendorless scripts use of gates
	UNSAFE_initIfNeeded();

	const value = FeatureGates.checkGate(gateName);
	addFeatureFlagAccessed(gateName, value);

	return value;
};
